import confetti from 'canvas-confetti';

/**
 * Triggers a professional confetti celebration animation from side cannons
 * Perfect for celebrating successful deal closures
 */
export const triggerWonCelebration = () => {
  const duration = 3 * 1000; // 3 seconds
  const animationEnd = Date.now() + duration;

  // Professional colors - matching the solar/energy theme
  // Blue and green tones with some gold for celebration
  const colors = ['#3b82f6', '#10b981', '#fbbf24', '#60a5fa', '#34d399'];

  const frame = () => {
    // Stop animation after duration
    if (Date.now() > animationEnd) return;

    // Left cannon
    confetti({
      particleCount: 2,
      angle: 60,
      spread: 55,
      startVelocity: 60,
      origin: { x: 0, y: 0.5 },
      colors: colors,
      ticks: 60,
      gravity: 0.8,
      scalar: 1.2,
      drift: 0,
    });

    // Right cannon
    confetti({
      particleCount: 2,
      angle: 120,
      spread: 55,
      startVelocity: 60,
      origin: { x: 1, y: 0.5 },
      colors: colors,
      ticks: 60,
      gravity: 0.8,
      scalar: 1.2,
      drift: 0,
    });

    requestAnimationFrame(frame);
  };

  frame();
};

/**
 * Triggers a more subtle success animation
 * Can be used for other achievements if needed
 */
export const triggerSubtleSuccess = () => {
  confetti({
    particleCount: 50,
    spread: 70,
    origin: { x: 0.5, y: 0.6 },
    colors: ['#3b82f6', '#10b981', '#60a5fa'],
    ticks: 50,
    gravity: 1,
    decay: 0.95,
    startVelocity: 30,
  });
};

/**
 * Triggers a burst animation from a specific position
 * @param x - X position (0 to 1)
 * @param y - Y position (0 to 1)
 */
export const triggerBurst = (x: number = 0.5, y: number = 0.5) => {
  confetti({
    particleCount: 30,
    spread: 360,
    origin: { x, y },
    colors: ['#3b82f6', '#10b981', '#fbbf24'],
    ticks: 40,
    gravity: 0.8,
    startVelocity: 20,
  });
};